import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function PageHero({ eyebrow, title, subtitle, crumbs = [], image }) {
  return (
    <section className="relative overflow-hidden bg-deep text-white" data-testid="page-hero">
      <div className="absolute inset-0">
        {image && (
          <img
            src={image}
            alt=""
            className="w-full h-full object-cover opacity-30"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-br from-deep via-deep/95 to-brand/70" />
        <div className="absolute inset-0 subtle-grain opacity-40" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
        {crumbs.length > 0 && (
          <nav className="flex items-center gap-1.5 text-xs text-white/60 mb-6 tracking-wide" data-testid="breadcrumbs">
            <Link to="/" className="hover:text-gold">Home</Link>
            {crumbs.map((c, idx) => (
              <React.Fragment key={idx}>
                <ChevronRight className="w-3.5 h-3.5" />
                {c.to ? (
                  <Link to={c.to} className="hover:text-gold">{c.label}</Link>
                ) : (
                  <span className="text-gold">{c.label}</span>
                )}
              </React.Fragment>
            ))}
          </nav>
        )}
        {eyebrow && (
          <div className="text-[11px] tracking-[0.25em] uppercase text-gold font-semibold mb-4">{eyebrow}</div>
        )}
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight max-w-3xl leading-[1.05]">{title}</h1>
        {subtitle && <p className="mt-5 text-white/75 max-w-2xl text-base sm:text-lg leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
